<template>

  <div>
    <v-app>
      <v-main>
      <!-- 给应用提供合适的间距 -->
      <!-- <v-container> -->
        <!-- <siteHeader></siteHeader> -->
        <div class="html-content">
          <!-- <v-app >
           <v-main fluid> -->
            <router-view/>
           <!-- </v-main>
          </v-app> -->
         
        </div>
    <tasks-center></tasks-center>
      <!-- </v-container> -->
    </v-main> 

    </v-app>
    <!-- <site-footer v-show="showFooter"></site-footer> -->
  </div>
</template>

<script>
import siteHeader from "./components/common/siteHeader";
import siteFooter from "./components/common/siteFooter";
import tasksCenter from "./components/common/taskscenter";
export default {
  name: "index",
  components: { siteHeader, siteFooter, tasksCenter },
  data(){
    return {
      showFooter: true
    }
  },
  mounted() {
    window.addEventListener( "message", e => {
      if( e.data ){
        switch( e.data.key ){
          case 'reader.runPbc' :
            this.$EventBus.$emit( "runPbc", e.data.value );
            break;
          case 'reader.setProp.currentFile' :
            this.$EventBus.$emit( "currentFile", e.data.value )
            break;
          case 'reader.notice' :
            this.showNotice( e.data?.value?.status || 'contrast', e.data?.value?.message );
            break;
        }
      }
    }, false );
    if (window.EventSource) {
      var eventkey = $func.getUUID_resource();
      window.eventkey = eventkey;
      let that = this;
      //   let eventurl="http://172.100.30.251:8080/msg/v1/msg/sse"
      let eventurl = `${config.serverUrl}/msg/v1/msg/sse?uid=${eventkey}`
      var evt_source = new EventSource(eventurl);
      window.evt_source = evt_source;
      window.evt_source.onmessage = evt => {
        if (evt.data) {
          let data = JSON.parse(evt.data)
          if (data.sseKey) {
            window.sseKey = data.sseKey;
          }
        }

        //  console.log(evt);
      };
      window.evt_source.onopen = e => {
        console.log( 'onopen', e);
      }
      // 链接报错
      window.evt_source.onerror = err => {
        if (err.type == 'error') {
            console.log( 'error', err );
        }
      }
      window.evt_source.addEventListener('runPbc', (e) => {
         console.log( 'runPbc', e);
        that.$EventBus.$emit("runPbc", e.data)
      })
      // 开始
      window.evt_source.addEventListener('runPbc_start', (e) => {
        that.$EventBus.$emit("runPbc_start", e.data)
        console.log( 'runPbc_start', e);
      })
      // 结束
      window.evt_source.addEventListener('runPbc_end', (e) => {
        that.$EventBus.$emit("runPbc_end", e.data)
        console.log( 'runPbc_end', e);
      })
      // 浏览器关闭，关闭sse
      window.onbeforeunload = function () {
        window.evt_source.close();
      }
    } else {
      console.error("浏览器不支持sse")
    }

    // this.$EventBus.$emit('opendialogTaskCenter')
  },
  methods : {
    showNotice( type, message ){
      let _msgType  = 'info';
      if( type == 'error' )
        _msgType  = 'error'
      else if( type == 'success' )
        _msgType  = 'success'
      else if( type == 'primary' )
        _msgType  = 'success'
      else if( type == 'warning' )
        _msgType  = 'warning'
      this.$message({ type: _msgType, message: message });
    }
  },
  created() {
    const userAgent = navigator.userAgent;
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    const isTablet = /iPad|Android/i.test(userAgent) && !/Mobile/i.test(userAgent);
    const isDesktop = !isMobile && !isTablet;
    if (isMobile) {
        window.deviceType = "mobile";
    } else if (isTablet) {
      window.deviceType = "tablet";
    } else {
      window.deviceType = "pc";
    }
  }
}
</script>

<style lang="less">
.html-content{
  min-height: 100vh;
}
body{
  margin: 0;
  padding: 0;
}
</style>
